export function createRoute(path, componentPath, name) {
  return {
    name: name || componentPath,
    path,
    component: () => import(`@/views/${componentPath}.vue`),
    props: true
  };
}

export function registerDynamicRoutes(router, options) {
  if (!Array.isArray(options)) return;
  options.forEach(opt => {
    let comp = opt.component.replace(/^@\/views\//, '').replace(/\.vue$/, '');
    const route = createRoute(opt.path, comp, opt.name);
    router.addRoute(route);
  });
}
